const GTM_ID = 'GTM-TF6GG2JM'

declare global {
  interface Window {
    dataLayer?: Record<string, any>[]
  }
}

let initialized = false

/**
 * Only load GTM on a real top-level page — not in the editor's sandboxed
 * preview iframe or on localhost — so analytics stays clean and third-party
 * script failures can never surface as an opaque "Script error." in the editor.
 */
function shouldLoadGtm(): boolean {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false
  }

  try {
    if (window.self !== window.top) return false
  } catch {
    return false
  }

  const host = window.location.hostname
  if (!host || host === 'localhost' || host === '127.0.0.1') return false

  return true
}

/**
 * Injects Google Tag Manager: the dataLayer bootstrap + gtm.js in <head>,
 * and the <noscript> iframe fallback at the top of <body>.
 */
export function initGtm() {
  if (initialized) return
  if (!shouldLoadGtm()) return
  initialized = true

  try {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    })

    if (!document.getElementById('gtm-script')) {
      const script = document.createElement('script')
      script.id = 'gtm-script'
      script.async = true
      script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
      script.onerror = () => {
        console.warn('[GTM] Container script failed to load.')
      }
      document.head.insertBefore(script, document.head.firstChild)
    }

    if (!document.getElementById('gtm-noscript')) {
      const noscript = document.createElement('noscript')
      noscript.id = 'gtm-noscript'
      const iframe = document.createElement('iframe')
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`
      iframe.height = '0'
      iframe.width = '0'
      iframe.style.display = 'none'
      iframe.style.visibility = 'hidden'
      noscript.appendChild(iframe)
      document.body.insertBefore(noscript, document.body.firstChild)
    }
  } catch (error) {
    // Analytics must never take down the app.
    console.warn('[GTM] Skipped injection:', error)
  }
}
